import React from "react";
import { Passenger } from "../../../state/models";
import { Ancillary } from "../../../state/models/Ancillary";
import { PassengerBox, SelectedService } from "./PassengerBox";
import { ToggleSwitch } from "../../../comps/toggle-switch";
import { ls } from "../../../locale";


type OversizedItemsProps = {
  hasItems: boolean;
  passengers: Passenger[];
  ancillaries: Ancillary[];
  currencyCode: string;
  onSelectService: (service: SelectedService) => void;
  onClearService: (service: SelectedService) => void;
  onToggle: (checked: boolean) => void;
};


export default function OversizedItems({hasItems, passengers, ancillaries, currencyCode, onSelectService, onClearService, onToggle }: OversizedItemsProps) {

  if(!Array.isArray(passengers)) return null;
  if(!Array.isArray(ancillaries)) return null;
  if(!ancillaries.some(a => Array.isArray(a.passengers) && a.passengers.some(p => Array.isArray(p.oversizedItems) && p.oversizedItems.length > 0))) return null;

  return (
    <div className='tw-mt-4 tw-mb-10 tw-shadow-outline-gray tw-bg-white'>
      <div className="tw-mb-0 tw-min-h-[125px]">
        <Header hasItems={hasItems} onToggle={onToggle} />
        {hasItems && <Description />}
      </div>
      {hasItems && (
        <div className='tw-flex tw-flex-col tw-gap-0'>
          {passengers.map((passenger, index) => (
            <PassengerBox key={index}
              serviceKey="oversizedItems"
              passenger={passenger} 
              ancillaries={ancillaries}
              currencyCode={currencyCode}
              onSelectService={onSelectService}
              onClearService={onClearService}
            />
          ))}
        </div>
      )}
    </div>
  );
}


function Header({hasItems, onToggle}: {hasItems: boolean, onToggle: (checked: boolean) => void}) {

  const rOversizedItems = ls.t('ExtraPage.OversizedItems');

  const handleHeaderClick = (e: React.MouseEvent<HTMLDivElement>) => {
    console.log('Header clicked, hasItems:', hasItems);
    e.stopPropagation();
    if (!hasItems) onToggle(true);
  };

  return (
    <div className='tw-p-4 tw-flex tw-flex-row tw-gap-2 tw-cursor-pointer' onClick={handleHeaderClick}>
      <div className="">
        <img src="/images/oversized-bike.png" alt="Oversized Items" height="80" />
      </div>
      <div className="tw-flex-1 tw-flex tw-flex-col tw-justify-between">
        <div className="tw-flex tw-flex-row tw-justify-between tw-items-center">
          <div className='tw-text-lg sa-text-green tw-uppercase'>{rOversizedItems.Title}</div>
          <div className="tw-px-2" onClick={e => e.stopPropagation()}>
            <ToggleSwitch checked={hasItems} onChange={onToggle} />
          </div>
        </div>
        <div>{rOversizedItems.Terms}</div>
      </div>
    </div>
  );
}

function Description() {
  const rOversizedItems = ls.t('ExtraPage.OversizedItems');
  return (
    <div className="tw-flex tw-flex-col md:tw-flex-row tw-border-0 tw-border-t tw-border-solid tw-border-gray-200">
      <div className="tw-flex-1 tw-flex tw-flex-row tw-flex-wrap tw-px-6">
        <ListItem title={rOversizedItems.Item1} image="oversized-1.png" />
        <ListItem title={rOversizedItems.Item2} image="oversized-2.png" />
        <ListItem title={rOversizedItems.Item3} image="oversized-3.png" />
        <ListItem title={rOversizedItems.Item4} image="oversized-4.png" />
        <ListItem title={rOversizedItems.Item5} image="oversized-5.png" />
        <ListItem title={rOversizedItems.Item6} image="oversized-6.png" />
      </div>
    </div>
  )
}

function ListItem({title, image}: {title: string, image: string}) {
  return (
    <div className="tw-w-1/2 md:tw-w-1/3 tw-p-2 tw-flex tw-flex-row tw-justify-start tw-items-center tw-gap-2">
      <img src={`/images/${image}`} alt={title} className="tw-size-10" />
      <div>{title}</div>
    </div>
  )
}

